








































































import {
  SettingManagementListSettingRequest,
  SettingManagementSettingService,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qInputMultipleLanguage",
  components: {
    QErrors,
  },
})
export default class qInputMultipleLanguage extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public languages;

  @Prop({
    type: String,
    default: "text",
  })
  public type;

  @Prop({
    type: String,
    default: "mb__form-text Small",
  })
  public inputClass;

  @Prop({
    required: true,
    type: String,
  })
  public category;

  @Prop({
    required: true,
    type: Object,
  })
  public errors;

  @Prop({
    required: true,
    type: Object,
    default: {
      ja: "",
      en: "",
      cn: "",
    },
  })
  public keyIndex;

  @PropSync("item", {
    type: String,
    default: "",
  })
  public itemSync;

  @PropSync("itemEn", {
    type: String,
    default: "",
  })
  public itemEnSync;

  @PropSync("itemCn", {
    type: String,
    default: "",
  })
  public itemCnSync;

  public updateValue(category, event) {
    const newValue = event.target._value;
    if (newValue != "") {
      this.getDict(newValue, category).then((producer) => {
        if (producer) {
          this.$emit("update:item", producer.context);
          this.$emit("update:itemEn", producer.context_en);
          this.$emit("update:itemCn", producer.context_cn);
        }
      });
    }
  }

  public clearError(name) {
    this.$emit("clearError", name);
  }

  private async getDict(keyword, category) {
    try {
      const result = await SettingManagementSettingService.adminSetting({
        categories: [category],
        word: keyword,
        disabledLoadinng: true,
        // 辞書検索は入力補助のため、失敗しても画面遷移させず入力を継続させる
        disabledForbiddenRedirect: true,
      } as SettingManagementListSettingRequest);

      return result.data.setting.length > 0 ? result.data.setting[0] : null;
    } catch (error) {
      // 辞書が引けなくても入力内容は保持し、登録処理は継続できるようにする
      console.warn("辞書の検索に失敗しました", error);

      return null;
    }
  }
}
